"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var utils_1 = require("@cian/utils");
var styles = require("./index.css");
exports.Icon = function (_a) {
    var isActive = _a.isActive;
    return (React.createElement("svg", tslib_1.__assign({}, utils_1.mergeStyles(styles['icon'], isActive && styles['icon--active']), { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14.004 14", width: "14", height: "14" }),
        React.createElement("path", { stroke: "#E84260", strokeWidth: "2", 
            // tslint:disable-next-line:max-line-length
            d: "M6.99 11.72L1.825 6.677C.727 5.582.725 3.805 1.82 2.707l.015-.015c1.118-1.08 2.962-1.08 4.092.014l.36.35.67.648.694-.62.394-.35.03-.028c1.13-1.095 2.973-1.095 4.104 0 1.1 1.093 1.103 2.87.01 3.968l-.015.015-5.182 5.03z" })));
};



//////////////////
// WEBPACK FOOTER
// ./src/shared/favorite_button/icon.tsx
// module id = 299
// module chunks = 2